import React, { useCallback } from "react";
import "./style.scss";

const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

interface Props {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

function ReactionPicker({ onSelect, onClose }: Props) {
  const handleSelect = useCallback(
    (emoji: string) => {
      onSelect(emoji);
      onClose();
    },
    [onSelect, onClose]
  );

  return (
    <div className="reaction-picker">
      {QUICK_REACTIONS.map((emoji) => (
        <button
          key={emoji}
          className="reaction-picker__emoji"
          onMouseDown={(e: React.MouseEvent) => { e.preventDefault(); handleSelect(emoji); }}
          type="button"
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}

export default ReactionPicker;
